module.exports = __webpack_public_path__ + "img/hover_icon_manejo_de_pago.2723496b.svg";